import appStorage from 'helpers/AppStorage';

const slicer = state => state.data.stores;

export const selectSelectedStoreId = (state, checkAppStorage) => slicer(state).selectedStore || (checkAppStorage && appStorage('selectedStore')) || '0';
export const selectStores = state => slicer(state).list ?? [];
